var CROP_METHODS = {
    FILL: 'FILL',
    FIT: 'FIT',
    MIN: 'MIN',
    MAX: 'MAX',
};
export default CROP_METHODS;
//# sourceMappingURL=layoutParams_crop_method.js.map